import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

const { reducer } = createSlice({
    name: 'name',
    initialState,
    reducers: {},
    extraReducers: {},
})

export default reducer
